import { OptionGroup } from '@/scopes/common/components/Filters/GroupedAirportFilter/OptionGroup'
import { GroupOption } from '@/scopes/common/components/Filters/GroupedAirportFilter/types'
import {
  DropdownMultiselectContext,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/DropdownMultiselect'
import { CheckboxState } from '@sunwebgroup/ui-components'
import * as React from 'react'

export function DropdownMultiselectOptionGroup({
  id,
  value,
  options,
}: {
  id: string
  value: string
  options: GroupOption[]
  trailing?: string | undefined
}) {
  const { selectedValues, removeOptions, addOptions } = React.useContext(DropdownMultiselectContext)

  const onGroupCheckedChangeHandler = (checked: CheckboxState) => {
    if (checked) {
      const notCheckedOptionsIds = options
        .filter(option => !selectedValues.includes(option.id))
        .map(option => option.id)
      addOptions(notCheckedOptionsIds)
    }
    else {
      const checkedOptionsIds = options
        .filter(option => selectedValues.includes(option.id))
        .map(option => option.id)
      removeOptions(checkedOptionsIds)
    }
  }

  const onOptionCheckedChangeHandler = ({ id: optionId, checked }: { id: string, checked: CheckboxState }) => {
    if (checked) {
      addOptions([optionId])
    }
    else {
      removeOptions([optionId])
    }
  }

  return (
    <OptionGroup
      value={id}
      text={value}
      selectedValues={selectedValues}
      options={options}
      onChange={onGroupCheckedChangeHandler}
      onChangeOption={onOptionCheckedChangeHandler}
    />
  )
}
